import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import {
    View,
    FlatList
} from 'react-native';

import {
    JDNativeSystem
} from '@jdreact/jdreact-core-lib';

import MovieItem from '../components/common/movie-item';
import PreWantMovieItem from '../components/common/pre-want-movieItem';
import Loading from '../components/common/loading';
import ScrollTopButton from '../components/index/scroll-top-button';

import { get } from '../common/fetch';
import { mtaPV, closeShare, fetchLocal } from '../common/utils';
import sgmReport from '../common/sgmUtil';

class AllMvoie extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            movieList: [],
            toTopIsShow: false
        };
        this.getAllMovie = this.getAllMovie.bind(this);
        this._goTop = this._goTop.bind(this);
    }

    _scroll;

    render() {
        const { movieList, toTopIsShow } = this.state;

        if (!movieList || movieList?.length === 0) {
            return (
                <View style={ { flex: 1 } }>
                    { this.setTitle('全部电影') }
                    <Loading contentStyle={ { flex: 1 } } />
                </View>
            );
        }

        return (
            <View style={ { flex: 1 } }>
                { this.setTitle('全部电影') }
                <FlatList
                    data={ movieList }
                    initialNumToRender={ 8 }
                    renderItem={ this.render_item }
                    keyExtractor={ (item) => item.movieId + '' }
                    showsVerticalScrollIndicator={ false }
                    ref={ (scroll) => { this._scroll = scroll; } }
                    onScroll={ (e) => this.onScroll(e) }
                    scrollEventThrottle={ 16 }
                    style={ { flex: 1 } }
                />
                {movieList.length > 0 && toTopIsShow && <ScrollTopButton goTop={ this._goTop } />}
            </View>
        );
    }

    componentDidMount() {
        this.getAllMovie();
        closeShare();
    }

    componentDidFocus() {
        mtaPV('MovList');
    }

    getAllMovie() {
        let { cityId } = this.props.cur_city;
        const movieCityHistory = fetchLocal('movieCityHistory');

        cityId = (movieCityHistory && movieCityHistory.rawData[0].cityId) || '';
        get('getMovieHotListVO', { cityId }).then((res) => {
            const movieList = res.data;

            this.setState({ movieList });

            if(movieList && movieList.length){
                const hasEmpty = movieList.some(item =>  !item.jdPicUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: 'getMovieHotListVO',message:'数据未返回图片地址！'}, 3)
                }
            }
        });

        if(!cityId){
            sgmReport('1001', {function_id: 'getMovieHotListVO',message:'缺少参数cityId'}, 3)
        }
    }

    // {/* canPreOrder 1=预售 2=热映 3=待映 */}
    render_item({ item }) {
        return item.canPreOrder === 2 ? <MovieItem from="allMovie" movieInfo={ item } /> : <PreWantMovieItem from="allMovie" movieInfo={ item } />;
    }

    onScroll(e) {
        JDNativeSystem.clearImageCache();
        const info = e.nativeEvent;

        const scrollHeight = info.contentOffset.y;

        const { toTopIsShow } = this.state;
        // if (scrollHeight >= innerHeight) {

        if (scrollHeight >= 1) {
            !toTopIsShow && this.setState({ toTopIsShow: true });
        } else {
            toTopIsShow && this.setState({ toTopIsShow: false });
        }
    }

    _goTop() {
        this._scroll.scrollToOffset({ animated: true, offset: 0 });
    }

    setTitle = (title) => {
        document.title = title;
    }
}

const select = (state) => {
    const { cur_city } = state.index;

    return { cur_city };
};

export default connect(select, null, null, { withRef: true })(AllMvoie);
